import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { Guid, TermSheetFacilityCollateral } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useTermSheetFacilityCollateralQuery(
	dataRoomGuid?: Guid | undefined,
	termSheetGuid?: Guid | null | undefined,
	revisionGuid?: Guid | null | undefined,
	facilityGuid?: Guid | null | undefined,
	options?:
		| Omit<
				UseQueryOptions<TermSheetFacilityCollateral[], unknown, TermSheetFacilityCollateral[], any>,
				'queryKey' | 'queryFn'
		  >
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.TermSheets.FacilityCollateral(dataRoomGuid, termSheetGuid, revisionGuid, facilityGuid),
		() =>
			AxiosUtils.getResponseData<TermSheetFacilityCollateral[]>(
				api.get(
					CerebroApiEndpoints.TermSheets.FacilityCollateral(
						dataRoomGuid,
						termSheetGuid,
						revisionGuid,
						facilityGuid
					)
				)
			),
		options
	);
}
